import React, { useMemo } from "react";

import { Icon, Popup } from "semantic-ui-react";

type LeaveTypeTooltipProps = {
  asTooltip: boolean;
};

const LeaveTypeTooltip = (props: LeaveTypeTooltipProps) => {
  const content = useMemo(
    () => (
      <div
        className="leave-form-field"
        style={{
          minWidth: "max-content",
          padding: "0.35rem 1.5rem 0.35rem 0.75rem",
          ...(!props.asTooltip && { position: "absolute", right: "8px", top: "2px" }),
        }}
      >
        <div className="leave-item" style={{ marginBottom: "0.25rem" }}>
          <div className="leave-badge">S</div>
          Leave type (Pending)
        </div>
        <div className="leave-item">
          <div className="leave-badge leave-badge--approved">S</div>
          Leave type (Approved)
        </div>
        <div
          style={{
            color: "#666",
            fontSize: "0.9em",
            lineHeight: "1.2",
            marginTop: "0.15rem",
            whiteSpace: "pre-wrap",
          }}
        >
          Each leave type is represented by the initial letter displayed{"\n"}inside a square. For
          example, &apos;S&apos; indicates Sick Leave.
        </div>
      </div>
    ),
    [props.asTooltip]
  );

  return props.asTooltip ? (
    <Popup
      style={{ padding: 0 }}
      content={content}
      position="bottom left"
      trigger={
        <div className="leave-info-icon">
          <Icon name="info circle" />
        </div>
      }
    />
  ) : (
    content
  );
};

LeaveTypeTooltip.displayName = "LeaveTypeTooltip";

export default React.memo(LeaveTypeTooltip);
